import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import instance from "../../../config/Config";

const initialState = {
    data: null,
    loading: false,
    error: null,
    count: null,

};

export const getRemarkList = createAsyncThunk(
    "getRemarkList",
    async (body) => {
        try {
            const response = await instance.get(
                `/crm/leads/demo-fetch-lead?page=${body?.page}&search=${body?.search}&project=${body?.project}&source=${body?.source}&dateSource=${body?.dateSource}&remark=${body.remark}&NoActivity=${body.NoActivity}&priority=${body.priority}&assignto=${body.assignto}&remindFilter=${body?.remindDateFilter}&isRegisterFilter=${body?.isRegisterFilter}&startDate=${body.startDate}&endDate=${body.endDate}&category=${body.category}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }
);



export const RLeadSlice = createSlice({
    name: "RLeadSlice",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getRemarkList.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(getRemarkList.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            state.count = action.payload?.count;
        });
        builder.addCase(getRemarkList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });


    },
});

export default RLeadSlice.reducer;
